//
// Copyright (C) 2023 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/VehicleServer.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DumpOptionsSchema } from "./DumpOptions_pb";
import { file_android_hardware_automotive_vehicle_DumpOptions } from "./DumpOptions_pb";
import type { DumpResultSchema } from "./DumpResult_pb";
import { file_android_hardware_automotive_vehicle_DumpResult } from "./DumpResult_pb";
import type { GetMinMaxSupportedValuesRequestSchema, GetMinMaxSupportedValuesResultSchema } from "./GetMinMaxSupportedValuesTypes_pb";
import { file_android_hardware_automotive_vehicle_GetMinMaxSupportedValuesTypes } from "./GetMinMaxSupportedValuesTypes_pb";
import type { GetSupportedValuesListsRequestSchema, GetSupportedValuesListsResultSchema } from "./GetSupportedValuesListsTypes_pb";
import { file_android_hardware_automotive_vehicle_GetSupportedValuesListsTypes } from "./GetSupportedValuesListsTypes_pb";
import type { SubscribeRequestSchema } from "./SubscribeRequest_pb";
import { file_android_hardware_automotive_vehicle_SubscribeRequest } from "./SubscribeRequest_pb";
import type { SupportedValuesChangeSchema } from "./SupportedValuesChange_pb";
import { file_android_hardware_automotive_vehicle_SupportedValuesChange } from "./SupportedValuesChange_pb";
import type { VehicleHalCallStatusSchema } from "./StatusCode_pb";
import { file_android_hardware_automotive_vehicle_StatusCode } from "./StatusCode_pb";
import type { UnsubscribeRequestSchema } from "./UnsubscribeRequest_pb";
import { file_android_hardware_automotive_vehicle_UnsubscribeRequest } from "./UnsubscribeRequest_pb";
import type { VehiclePropConfigSchema } from "./VehiclePropConfig_pb";
import { file_android_hardware_automotive_vehicle_VehiclePropConfig } from "./VehiclePropConfig_pb";
import type { VehiclePropValuesSchema } from "./VehiclePropValue_pb";
import { file_android_hardware_automotive_vehicle_VehiclePropValue } from "./VehiclePropValue_pb";
import type { GetValueResultsSchema, SetValueResultsSchema, UpdateSampleRateRequestSchema, VehiclePropValueRequestsSchema } from "./VehiclePropValueRequest_pb";
import { file_android_hardware_automotive_vehicle_VehiclePropValueRequest } from "./VehiclePropValueRequest_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file android/hardware/automotive/vehicle/VehicleServer.proto.
 */
export const file_android_hardware_automotive_vehicle_VehicleServer: GenFile = /*@__PURE__*/
  fileDesc("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", [file_android_hardware_automotive_vehicle_DumpOptions, file_android_hardware_automotive_vehicle_DumpResult, file_android_hardware_automotive_vehicle_GetMinMaxSupportedValuesTypes, file_android_hardware_automotive_vehicle_GetSupportedValuesListsTypes, file_android_hardware_automotive_vehicle_SubscribeRequest, file_android_hardware_automotive_vehicle_SupportedValuesChange, file_android_hardware_automotive_vehicle_StatusCode, file_android_hardware_automotive_vehicle_UnsubscribeRequest, file_android_hardware_automotive_vehicle_VehiclePropConfig, file_android_hardware_automotive_vehicle_VehiclePropValue, file_android_hardware_automotive_vehicle_VehiclePropValueRequest, file_google_protobuf_empty]);

/**
 * @generated from service android.hardware.automotive.vehicle.proto.VehicleServer
 */
export const VehicleServer: GenService<{
  /**
   * @generated from rpc android.hardware.automotive.vehicle.proto.VehicleServer.GetAllPropertyConfig
   */
  getAllPropertyConfig: {
    methodKind: "server_streaming";
    input: typeof EmptySchema;
    output: typeof VehiclePropConfigSchema;
  },
  /**
   * @generated from rpc android.hardware.automotive.vehicle.proto.VehicleServer.SetValues
   */
  setValues: {
    methodKind: "unary";
    input: typeof VehiclePropValueRequestsSchema;
    output: typeof SetValueResultsSchema;
  },
  /**
   * @generated from rpc android.hardware.automotive.vehicle.proto.VehicleServer.GetValues
   */
  getValues: {
    methodKind: "unary";
    input: typeof VehiclePropValueRequestsSchema;
    output: typeof GetValueResultsSchema;
  },
  /**
   * @generated from rpc android.hardware.automotive.vehicle.proto.VehicleServer.UpdateSampleRate
   */
  updateSampleRate: {
    methodKind: "unary";
    input: typeof UpdateSampleRateRequestSchema;
    output: typeof VehicleHalCallStatusSchema;
  },
  /**
   * @generated from rpc android.hardware.automotive.vehicle.proto.VehicleServer.CheckHealth
   */
  checkHealth: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof VehicleHalCallStatusSchema;
  },
  /**
   * @generated from rpc android.hardware.automotive.vehicle.proto.VehicleServer.Dump
   */
  dump: {
    methodKind: "unary";
    input: typeof DumpOptionsSchema;
    output: typeof DumpResultSchema;
  },
  /**
   * @generated from rpc android.hardware.automotive.vehicle.proto.VehicleServer.StartPropertyValuesStream
   */
  startPropertyValuesStream: {
    methodKind: "server_streaming";
    input: typeof EmptySchema;
    output: typeof VehiclePropValuesSchema;
  },
  /**
   * @generated from rpc android.hardware.automotive.vehicle.proto.VehicleServer.Subscribe
   */
  subscribe: {
    methodKind: "unary";
    input: typeof SubscribeRequestSchema;
    output: typeof VehicleHalCallStatusSchema;
  },
  /**
   * @generated from rpc android.hardware.automotive.vehicle.proto.VehicleServer.Unsubscribe
   */
  unsubscribe: {
    methodKind: "unary";
    input: typeof UnsubscribeRequestSchema;
    output: typeof VehicleHalCallStatusSchema;
  },
  /**
   * @generated from rpc android.hardware.automotive.vehicle.proto.VehicleServer.GetMinMaxSupportedValues
   */
  getMinMaxSupportedValues: {
    methodKind: "unary";
    input: typeof GetMinMaxSupportedValuesRequestSchema;
    output: typeof GetMinMaxSupportedValuesResultSchema;
  },
  /**
   * @generated from rpc android.hardware.automotive.vehicle.proto.VehicleServer.GetSupportedValuesLists
   */
  getSupportedValuesLists: {
    methodKind: "unary";
    input: typeof GetSupportedValuesListsRequestSchema;
    output: typeof GetSupportedValuesListsResultSchema;
  },
  /**
   * @generated from rpc android.hardware.automotive.vehicle.proto.VehicleServer.StartSupportedValuesChangeStream
   */
  startSupportedValuesChangeStream: {
    methodKind: "server_streaming";
    input: typeof EmptySchema;
    output: typeof SupportedValuesChangeSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_android_hardware_automotive_vehicle_VehicleServer, 0);

